// extracted by mini-css-extract-plugin
export default {"student_cb_alert_top_bar":"student_cb_alert_top_bar-T67wX"};